import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoiceCpComRequestQueueContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_cp_com_request_queue_container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiVisa, BasicApiResponseModel } from '../shared';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MyEInvoiceCpComRequestQueueService extends BaseApiPublicLoginTemplateService<MyEInvoiceCpComRequestQueueContainerModel, MyEInvoiceCpComRequestQueueContainerModel, MyEInvoiceCpComRequestQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-queues/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-queues/backoffice-ep'
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-queues/'+ BaseApiTemplateService.LOGIN_ENTITY_EP
    this.httpClient = http;
  }

  processRequestLoginEntity(dto: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-queues/process-request/login-entity-ep';
    let endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-queues/process-request/login-entity-ep';
    if (visa.api_domain_url) {
      apiUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }

  processRequestBackOfficeEp(dto: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-queues/process-request/backoffice-ep';
    let endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-queues/process-request/backoffice-ep';
    if (visa.api_domain_url) {
      apiUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }

  processRequestWebsiteEp(websiteHdrGuid: string, dto: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-queues/process-request/website-ep/' + websiteHdrGuid;
    let endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-queues/process-request/website-ep/' + websiteHdrGuid;
    if (visa.api_domain_url) {
      apiUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }
}
